<div class="edit-popup">
  <div class="close" (click)="close()"></div>
  <div class="modal-container">
    @if (add) {
      <h1>{{'Edit field' | translate}}</h1>
    }
    @if (!add) {
      <h1>{{'Add field' | translate}}</h1>
    }
    <form #form="ngForm" (ngSubmit)="onConfirm()" novalidate>
      <div class="form-content">
        @switch (data.formType) {
          @case ('input') {
            <div class="row">
              <div class="L-12 M-12 S-12 columns">
                <label>{{data.title | translate}}</label>
                <input class="input-popup" [type]="data.inputType" [name]="data.var_name" [(ngModel)]="data.item" placeholder="{{'Insert' | translate }}">
              </div>
            </div>
          }
          @case ('textarea') {
            <div class="row">
              <div class="L-12 M-12 S-12 columns">
                <label>{{data.title | translate}}</label>
                <textarea class="textarea-popup" style="resize: vertical;" type="text" [name]="data.var_name" [(ngModel)]="data.item"></textarea>
              </div>
            </div>
          }
          @case ('') {
          }
        }
        @if (data?.showCheck) {
          <div class="L-12 M-12 S-12 columns upper">
            <input type="checkbox" name="check" [(ngModel)]="data.valueCheck">
            <p class="checkbox">{{$safeNavigationMigration(data?.textCheck) | translate}}</p>
          </div>
        }
      </div>
      <div class="content-buttons">
        <div class="row">
          <div class="L-6 M-6 S-6 columns content-single-btn">
            <button type="submit" class="btn-confirm">{{'Confirm' | translate}}</button>
          </div>
          <div class="L-6 M-6 S-6 columns content-single-btn">
            <button type="button" (click)="close()" class="btn-cancel">{{'Cancel' | translate}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
